import React from 'react';
import AddBenefit from 'components/widgets/modals/AddBenefit';
// import Add_Benefit from '../forms/setup/Add_Benefit';
import Add_Product_Benefit from 'components/widgets/forms/setup/Add_Benefit';

function Benefit(props) {
    return (
        <div>
            Single product
            <Add_Product_Benefit />
        </div>
    );
}

export default Benefit;